<div class="flex flex-col space-y-2">
    <h1 class="text-2xl font-bold text-center">Cambios en versión {{appVersion}}</h1>
    <mat-divider></mat-divider>
    <div class="prose" markdown ngPreserveWhitespaces>
        {{changelog}}
    </div>
    <mat-divider></mat-divider>
    <button mat-flat-button color="primary" class="w-full" (click)="accept()">
        Aceptar cambios
    </button>
</div>